import { render, staticRenderFns } from "./printprofile.vue?vue&type=template&id=1b7f9756&"
import script from "./printprofile.vue?vue&type=script&lang=js&"
export * from "./printprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports